import { BaseDto } from '../base.dto';
import { IsInt, IsOptional, IsString, Length, Matches } from 'class-validator';
import { Exclude } from 'class-transformer';
import { validationPatterns } from '../../constants';

export class BankingHouseAccountApprovalUpdateDto extends BaseDto {
  @Exclude()
  orderPaymentId: number;

  @IsOptional()
  @IsInt()
  houseAccountId: number;

  @IsOptional()
  @IsInt()
  approvedEmployeeId: number;

  @IsOptional()
  @IsString()
  @Length(0, 255)
  @Matches(validationPatterns.noteValidation)
  description:string;
}
